import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import images from './Images'

const fall = {
  background: images.fall,
  gradient: ['#FFBB69', '#FD7457'],
  accent: Colors.white,
  ...images.fallCard,
}

const winter = {
  background: images.winter,
  gradient: ['#BADDFF', '#6695CE'],
  accent: '#152439',
  ...images.winterCard,
}

const web = {
  background: images.webBackground,
  accent: '#333333',
  ...images.webCard,
}

export { fall, winter, web }

